import React, { useState } from "react";
import AppSidebar from "../sidebar/Sidebar.jsx";
import { motion } from "framer-motion";
import Header from "../header/Header.jsx";

export default function AppLayout({ children, title = "Tax Tribe" }) {
  const [collapsed, setCollapsed] = useState(true);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <div>
      <div className="flex ">
        <motion.div
          className="hidden lg:block"
          animate={{
            marginLeft: collapsed ? "0px" : "-260px",
            transition: { duration: 0.5 },
          }}
        >
          <AppSidebar />
        </motion.div>

        {isDrawerOpen && (
          <div initial={{ x: "-100%" }}
          animate={{ x: 0, transition: { duration: 0.5, ease: "easeOut" } }}
          className="h-full w-full">
            <motion.div
              initial={{ x: "-100%" }}
              animate={{ x: 0, transition: { duration: 0.5, ease: "easeOut" } }}
              className="h-full w-full"
            >
              <div className="bg-white w-[250px] h-screen">
                <AppSidebar close={() => setIsDrawerOpen(false)} />
              </div>
              <div
                className="fixed left-[255px] top-[10px]"
                onClick={() => setIsDrawerOpen(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="w-6 h-6 cursor-pointer"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              </div>
            </motion.div>
          </div>
        )}

        <div
          className={`bg-white lg:ml-[260px] ${
            collapsed ? "lg:w-[calc(100%-260px)]" : "lg:w-full"
          } w-full`}
        >
          <Header
            collapsed={collapsed}
            title={title}
            setCollapsed={setCollapsed}
            isDrawerOpen={isDrawerOpen}
            setIsDrawerOpen={setIsDrawerOpen}
          />
          <div className="px-2 md:px-4 pt-2 md:pt-4">{children}</div>
        </div>
      </div>
    </div>
  );
}
